import { Injectable } from "@angular/core";
import { AddressPayload, CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, MyVehicleAllForChange, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload, VehicleLogPayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload, RegisterMemberResponse } from "../../../models/member.model";
import { StatusAPIResponse, StatusAPIResponseMain, TaxpayerInfo } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { RequestFullTaxPayload } from "../../../models/payment.model";
import { ActivateVehicleInfo, CardByVehicleTypeInfo, ConfirmActivateMemberPayload } from "../../../models/activate.model";

@Injectable({
    providedIn: 'root',
})

export class ApiActiveMemberService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
    ) { }

    getMyMemberActivate(
    uid: string,
    token: string,
  ): Observable<ActivateVehicleInfo[]> {
    console.log('this Token : ', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/Cityparking/GetMyMemberActivate';
    const params = new HttpParams().set('uid', uid);
    console.log(
      '📨 Sent Api GetMyMemberActivate : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<ActivateVehicleInfo[]>(url, {
      headers,
      params,
    });
  }


    updateMyMemberActivate(
      token: string,
      payload: ConfirmActivateMemberPayload,
    ): Observable<StatusAPIResponse> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      // console.log(
      //   '📨 Sent Api Activate Member Card : ',
      //   this.tokenUrl + '/Cityparking/ActiveMemberCode',
      //   headers,
      //   payload
      // );
  
      return this.http.patch<StatusAPIResponse>(
        this.tokenUrl + '/Cityparking/ActiveMemberCode',
        payload,
        {
          headers,
        },
      );
    }
}